import React, { useEffect, useRef } from "react";
import { Header } from "../header";
import Banner from "../../../src/assets/images/why_thy-01.webp";
import Back1 from "../../../src/assets/images/back1.webp";
import { WhatsappIcon } from "../overlay/whatsapp";
import { Footer } from "../footer";
import "./why-thy.css"
export const WhyThy = () => {
    const headerRef:any=useRef();
    useEffect(()=>{
        headerRef?.current?.scrollIntoView({ behavior: 'smooth' });
    },[])
    return (
        <div className="why-thy-container" ref={headerRef}>
            <Header />
            <div style={{display:"flex",alignItems:"center",justifyContent:"center",width:"100%",flexDirection:"column"}}>
               <div
  className="why-thy-title"
  style={{
    backgroundImage: `url(${Back1})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    color: 'white',
    padding: '60px 20px',
    width: '100%',
    textAlign: 'center',
  }}
>
  ABOUT US
</div>
<div className="divider"></div>

                 <div className="why-thy-content">
               
                <div className="why-thy-description">
                    <p>Welcome to GEES, your trusted partner in providing high-quality power production machinery such as diesel generators, agricultural equipment, and construction machinery since 2020. As a registered certified export-import business, we are committed to delivering reliable and efficient products to overseas customers, ensuring top-tier performance and customer satisfaction. Our dedicated team works tirelessly to source, supply, and support our clients with innovative solutions tailored to their needs. At GEES, we pride ourselves on building long-term partnerships and contributing to your success through our exceptional products and professional service.</p>
                </div>
            </div>
               </div>
          
            <div className="why-thy-banner-container">
                 <img src={Banner} alt="Why Thy Banner" className="why-thy-banner-image" />
            </div>
            <div className="why-thy-details">
                <div className="why-thy-details-box">
                    <p>We specialize in quality engineering products that deliver numerous benefits to our customers, including enhanced efficiency, durability, and precision in their projects. Our engineering solutions are designed to improve productivity, reduce operational costs, and ensure reliable performance in various industrial applications. By choosing our products, customers gain access to innovative technology, superior craftsmanship, and exceptional support, empowering them to achieve their goals more effectively and maintain a competitive edge in their respective fields.
</p>

                    <p>
                       We offer a wide range of high-quality agricultural food products that provide numerous benefits to our customers, including freshness, nutritional value, and reliable supply. Our products are sourced from trusted farmers and suppliers, ensuring freshness and quality that meet global standards. By choosing our agricultural food products, customers enjoy healthier options, consistent availability, and the assurance of safety and sustainability. Whether for retail, wholesale, or food service, our offerings help businesses meet consumer demand for nutritious, premium-quality food while supporting sustainable agricultural practices.
                    </p>

                </div>
            </div>
            <WhatsappIcon/>
            <Footer />
        </div>
    )
}